'use client';

import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { FaLongArrowAltRight } from "react-icons/fa";

export function WelcomeSlide({ onStepComplete }) {
  const [pending, setPending] = useState(false);

  async function onNext() {
    setPending(true);
    try {
      // Trigger onboarding process
      onStepComplete();
    } catch (error) {
      console.error("Error starting onboarding:", error);
    } finally {
      setPending(false);
    }
  }

  return (
    <Card className="w-full max-w-4xl bg-white text-black shadow-md rounded-lg">
      <CardContent className="p-6 text-center">
        <div className="space-y-6">
          <h1 className="text-3xl font-semibold">Welcome to Samsearch!</h1>
          <p className="text-lg text-gray-700">
            We're excited to have you onboard. To begin, let's start by setting up your business profile.
          </p>
          <p className="text-sm text-gray-500">
            You can always update your information later. Let's get started!
          </p>

          <div className="mt-6 flex justify-center">
            <Button
              onClick={onNext}
              disabled={pending}
              className="px-6 py-3 text-white font-semibold rounded-lg flex items-center justify-center"
            >
              {pending ? "Starting..." : "Let's Get Started"}
              {!pending && <FaLongArrowAltRight className="ml-2" />}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default WelcomeSlide;
